var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuckduckgo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 256,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 256000 256000",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128000,
    cy: 128000,
    fill: "#da4a26",
    r: 127999
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127258 65156c-1245-1560-2774-3072-4599-4524-2044-1628-4461-3194-7265-4684-5395-2865-11459-4862-17733-5853-6119-965-12436-963-18521 142l212 4855c277 25 1185 600 2209 1280-3181 915-6119 2223-6074 6106l31 2689 2661-267c4520-452 9256-315 13896 403 1417 219 2825 492 4213 819l-665 178c-3146 858-5990 1926-8346 3170-7120 3741-11617 9361-13868 16672-2176 7070-2196 15664-420 25618l10 9c2330 13011 9870 48676 16018 77753 3043 14398 5752 27204 7253 34523 502 2438 775 4774 849 7003 46 1397 14 2764-90 4097-69 893-170 1771-301 2634l4865 1788 52101-252 4404-3232c-325-656-651-1314-980-1975-3539-7096-7308-14309-10564-20544-2368-4531-4464-8541-6007-11626-4127-8249-8253-18379-10505-28056-1351-5802-2020-11400-1586-16251-2355-966-4106-1815-4917-2398l-1 2c-2188-1569-4787-4325-6435-7649-1325-2673-2061-5729-1560-8898 488-3052 4205-7187 8898-10379v-9c4086-2778 9039-5001 13281-5279 1204-78 2509-154 3691-224 5146-300 7729-450 12995-1756 1674-415 4029-1009 6697-1706 364-6262-915-13476-3237-20497-3385-10236-9028-20192-15019-26186-1931-1932-4334-3506-7063-4760-2596-1193-5483-2094-8528-2736z",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130027 65156c-1244-1560-2773-3072-4598-4524-2045-1628-4461-3194-7265-4684-5395-2865-11459-4862-17733-5853-6119-965-12436-963-18522 142l211 4855c278 25 1186 600 2210 1280-3182 915-6118 2223-6074 6106l31 2689 2662-267c4520-452 9256-315 13895 403 1418 219 2824 492 4213 819l-665 178c-3146 858-5989 1926-8345 3170-7121 3741-11619 9361-13869 16672-2176 7070-2195 15664-419 25618l9 9c2331 13011 9871 48676 16018 77753 3044 14398 5752 27204 7252 34523 504 2438 775 4774 850 7003 47 1397 14 2764-89 4097-70 893-171 1771-301 2634l4865 1788 52100-252 4405-3232c-325-656-652-1314-981-1975-3538-7096-7307-14309-10565-20544-2368-4531-4462-8541-6007-11626-4126-8249-8251-18379-10504-28056-1350-5802-2019-11400-1585-16251-2356-966-4106-1815-4917-2398l-3 2c-2187-1569-4785-4325-6433-7649-1326-2673-2061-5729-1562-8898 488-3052 4206-7187 8900-10379v-9c4085-2778 9039-5001 13279-5279 1206-78 2510-154 3691-224 5146-300 7730-450 12997-1756 1673-415 4028-1009 6697-1706 363-6262-916-13476-3238-20497-3385-10236-9028-20192-15020-26186-1930-1932-4333-3506-7062-4760-2596-1193-5482-2094-8528-2736z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243692 128001c0-30784-12121-60038-33887-81805-21766-21766-51022-33887-81805-33887s-60037 12121-81805 33887c-21766 21767-33887 51021-33887 81805 0 30783 12121 60038 33888 81803 21767 21766 51021 33887 81804 33887s60037-12121 81804-33887c21767-21765 33888-51020 33888-81803zm-37369 78322c-20840 20841-48850 32445-78323 32445s-57483-11604-78323-32445c-20841-20840-32446-48849-32446-78322 0-29474 11604-57484 32445-78324 20840-20841 48851-32445 78324-32445s57484 11604 78324 32445c20841 20840 32445 48850 32445 78324 0 29473-11605 57482-32446 78322z",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191791 151602c0-5-1-3-1 0z",
    fill: "#212121",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201200 120750c4-23-4-7-18 17z",
    fill: "#212121",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200085 112307c-4450-1745-11522-1951-14357-581-1770 856-5499 2074-9779 3339-3960 1170-8291 2354-12022 3339-2722 719-5124 1332-6832 1759-5372 1348-8008 1503-13257 1812-1204 71-2535 150-3765 231-4325 287-9378 2581-13546 5447v9c-4787 3293-8579 7558-9077 10707-510 3269 240 6423 1593 9180 1680 3429 4331 6273 6563 7891l1-2c828 601 2614 1478 5016 2474 4005 1662 9723 3657 15576 5267 6709 1846 13711 3240 18722 3140 5271-106 11959-1618 17622-3796 3407-1309 6494-2878 8751-4549 2746-2034 4415-4373 4369-6882-11-598-110-1174-303-1725l-3 1c-1785-5085-7749-3629-16236-1556-7208 1761-16605 4057-26001 3144-5008-487-8376-1633-10443-3097-917-651-1528-1334-1874-2017-301-594-411-1206-358-1803 60-679 336-1391 784-2088l-5-5c1209-1863 3551-1495 6758-989 3986 628 8954 1412 15232-556 6097-1902 13503-4599 20183-7289 6524-2628 12320-5243 15498-7106 3918-2287 5781-4526 6245-6594 419-1869-137-3458-1369-4780-904-968-2193-1739-3686-2325z",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_396628272"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m102232 227038-2708-36819c1701-3493 24366 7292 29597 9016l1652 19160c-4848 2591-25545 17261-28541 8643z",
    fill: "#64bb46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125210 202374s10885-8180 20126-3559c0 0 2619 14636 0 18483 0 0-7186 4083-19764 2041z",
    fill: "#43a144"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#64bb46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m126374 200959s10885-8179 20125-3559c0 0 2619 14636 0 18483 0 0-7185 4083-19764 2042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144286 200416c7878-4771 32883-26364 30233-5594l-594 25086c48 995-434 1394-1348 1306l-30457-7442z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_396626088"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99603,
    cy: 111708,
    fill: "#2c4f8e",
    r: 7388
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102951,
    cy: 109207,
    fill: "#fffffe",
    r: 1885
  })), /*#__PURE__*/React.createElement("g", {
    id: "_396600048"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 138161,
    cy: 104592,
    fill: "#2c4f8e",
    r: 6330
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141029,
    cy: 102449,
    fill: "#fffffe",
    r: 1615
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2c4f8e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91804 92332c5269-3311 10686-861 10686-861s-3632-4792-11093-1737c-7452 3052-4656 9282-4656 9282s-196-3380 5063-6684z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137371 87399c-7942-1309-8984 5227-8984 5227s1695-2740 7900-2821c3021-41 6914 2183 6914 2183s-1527-3874-5830-4589z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 1h255998v255998h-255998z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuckduckgo);
export default __webpack_public_path__ + "static/media/duckduckgo.0dd5d5037d35dc41ec246b586d1b15f4.svg";
export { ForwardRef as ReactComponent };